import { render, staticRenderFns } from "./FormOptionDetailsBoxInfo.vue?vue&type=template&id=6f464c92&scoped=true&"
import script from "./form-option-details-box-info.js?vue&type=script&lang=js&"
export * from "./form-option-details-box-info.js?vue&type=script&lang=js&"
import style0 from "./form-option-details-box-info.scss?vue&type=style&index=0&id=6f464c92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f464c92",
  null
  
)

export default component.exports